import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Flex } from 'Components/Base';
import Menu from 'Containers/Menu';

import getRoutes from '../routes';

const Wrapper = styled(Flex)`
  height: 100%;
`;

const WebAppLayoutFullHeight = ({ children, menu, contentContainerProps, footer }) => {
  const menus = getRoutes(false);
  return (
    <Wrapper flexDirection={'column'} width={1}>
      {menu && <Menu menus={menus} hideMenu={true} />}
      <Flex flexDirection="column" {...contentContainerProps}>
        {children}
      </Flex>
      {/* {footer && <Box mt={'auto'}>add footer here</Box>} */}
    </Wrapper>
  );
};

WebAppLayoutFullHeight.propTypes = {
  menu: PropTypes.bool,
  footer: PropTypes.bool,
  contentContainerProps: PropTypes.object,
};

WebAppLayoutFullHeight.defaultProps = {
  menu: true,
  footer: false,
};
export default WebAppLayoutFullHeight;
